import { useSelector } from 'react-redux';
import { CaretDownFilled } from '@ant-design/icons';
import { Table as AntTable, Checkbox, Dropdown, Typography } from 'antd';
import { SearchFilters, expandIcon } from "datastake-daf/dist/components";
import { hasFilter } from 'datastake-daf/src/helpers/Filters';
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  dataMaper,
  selectMaper,
  getConfig,
  defaultSelectOptions,
} from './config';
import { Style } from './style';
import DafTable from '../../../Table/newTable';
import TablePagination from '../../../Table/pagination';
import { filterParams, useFilters } from '../../../../helpers/SubjectSearch';
import { EventsService, LirService, SCLService, StakeholderService } from "../../../../services";
import { Animated } from '../../../../screens/Modules/pme/screens/dashboard/widgets/tasks';

export const PTable = ({
  columns,
  rowSelection,
  data,
  setData,
  mod,
  published = false,
  selectOption = null,
  options,
  reset,
  t = (s) => s,
  setActiveFilters = () => { },
  fetchOptions = {},
  state = 'locations',
  defaultActiveFilters = {},
  onActiveFiltersChange = () => { },
  setUnpublishedCountAll = () => { },
}) => {
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectOptions, setSelectOptions] = useState(defaultSelectOptions[state]);
  const [toggledKeys, setToggledKeys] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const { user } = useSelector(state => state.authentication);
  const mounted = useRef(true);
  const loadingKeys = useRef({});

  useEffect(() => () => {
    mounted.current = false;
  }, []);

  const dataSource = useMemo(() => {
    const _s = dataMaper[state](data);
    return _s.map((s, i) => s.version ? ({
      ...s,
      children: undefined,
      key: `${s.id}-${i}`,
      versions: s.version,
      kids: (s.children || []).map((k, j) => ({
        ...k,
        key: `${k.id}-${j}-${i}`,
      })),
    }) : ({
      ...s,
      key: `${s.id}-${i}`,
    }));
  }, [data, state]);

  const _columns = useMemo(() => {
    if (rowSelection) {
      const _allDbIds = [];
      dataSource.forEach((k) => {
        _allDbIds.push({ dbId: k.dbId, id: k.id });
        if (k.kids) {
          k.kids.forEach((d) => {
            _allDbIds.push({ dbId: d.dbId, id: d.id });
          })
        }
      })

      const isAll = rowSelection.rowSelectionMode === 'all';
      const selectedRowKeys = isAll ?
        (rowSelection.selectedRowKeys || [])
          .filter((k) => dataSource.find((s) => s.dbId === k.dbId || (s.kids || []).find((d) => d.dbId === k.dbId))) :
        _allDbIds.filter((s) => !(rowSelection.rowSelectionExcluded || []).find((d) => d.dbId === s.dbId));

      const dataSourceLength = dataSource.reduce((all, item) => {
        if (Array.isArray(item.kids)) {
          return all + 1 + item.kids.length;
        }
        return all + 1;
      }, 0);

      const checked = dataSourceLength ? (selectedRowKeys || []).length === dataSourceLength : false;
      const hasSelected = !!selectedRowKeys.length;

      const menuItems = [
        {
          key: "details",
          onClick: () => {
            rowSelection.onChange(isAll ?
              [..._allDbIds, ...rowSelection.selectedRowKeys]
              : _allDbIds);
            rowSelection.setRowSelectionMode('all');
            rowSelection.setRowSelectionExcluded([]);
          },
          label: (
            <Typography.Text ellipsis={{ tooltip: t('Select all in this page') }} style={{ maxWidth: 135 }}>
              {t('Select all in this page')}
            </Typography.Text>
          ),
        },
        {
          key: "publish",
          onClick: () => {
            rowSelection.setRowSelectionMode('excluded');
            rowSelection.setRowSelectionExcluded([]);
            rowSelection.onChange([]);
          },
          label: (
            <Typography.Text ellipsis={{ tooltip: t('Select all') }} style={{ maxWidth: 160 }}>
              {t('Select all')}
            </Typography.Text>
          ),
        },
      ];

      return [
        {
          title: hasSelected ? (
            <div className="flex flex-row cursor-pointer">
              <Checkbox
                indeterminate={checked ? false : !!selectedRowKeys.length}
                checked={checked}
                onChange={() => {
                  if (isAll) {
                    rowSelection.onChange(rowSelection.selectedRowKeys.filter((s) =>
                      !selectedRowKeys.includes(s)));
                  } else {
                    rowSelection?.clean();
                  }
                }}
              />
              <Dropdown menu={{ items: menuItems }} trigger="click">
                <div className="flex flex-column justify-content-center ml-1" style={{ marginTop: 0 }}>
                  <CaretDownFilled />
                </div>
              </Dropdown>
            </div>
          ) : (
            <Dropdown menu={{ items: menuItems }} trigger="click">
              <div className="flex flex-row cursor-pointer">
                <Checkbox
                  indeterminate={checked ? false : !!selectedRowKeys.length}
                  checked={checked}
                />
                <div className="flex flex-column justify-content-center ml-1" style={{ marginTop: 0 }}>
                  <CaretDownFilled />
                </div>
              </div>
            </Dropdown>
          ),
          dataIndex: 'checkbox',
          key: 'checkbox',
          show: true,
          primarySearch: true,
          render: (name, item) => {
            return (
              <Checkbox
                checked={
                  isAll ?
                    (rowSelection.selectedRowKeys || []).find((it) => it.dbId === item.dbId) :
                    !(rowSelection.rowSelectionExcluded || []).find((it) => it.dbId === item.dbId)
                }
                onChange={(e) => {
                  const _kidsIds = (item?.kids || []).map((k) => ({ dbId: k.dbId, id: k.id }));

                  if (isAll) {
                    // No exclude

                    // Checked
                    if (e.target.checked) {
                      // Is Main
                      if (_kidsIds.length) {
                        rowSelection.onChange([
                          ...rowSelection.selectedRowKeys.filter((d) => !_kidsIds.find((k) => d.dbId === k.dbId)),
                          { dbId: item.dbId, id: item.id },
                          ..._kidsIds,
                        ]);
                      } else {
                        // Not Main
                        rowSelection.onChange([...rowSelection.selectedRowKeys, { dbId: item.dbId, id: item.id }]);
                      }
                    } else {
                      // Not Checked

                      // Is Main
                      if (_kidsIds.length) {
                        rowSelection.onChange(rowSelection.selectedRowKeys.filter((k) =>
                          k.dbId !== item.dbId && !_kidsIds.find((d) => d.dbId === k.dbId)));
                        // Not Main
                      } else {
                        rowSelection.onChange(rowSelection.selectedRowKeys.filter((k) => k.dbId !== item.dbId));
                      }
                    }
                  } else {
                    // With Exclude

                    // Checked
                    if (e.target.checked) {
                      // Is Main
                      if (_kidsIds.length) {
                        rowSelection.setRowSelectionExcluded(
                          rowSelection.rowSelectionExcluded.filter((k) =>
                            k.dbId !== item.dbId && !_kidsIds.find((d) => d.dbId === k.dbId)
                          )
                        );
                      } else {
                        // Not Main
                        rowSelection.setRowSelectionExcluded(
                          rowSelection.rowSelectionExcluded.filter((k) => k.dbId !== item.dbId)
                        );
                      }
                    } else {
                      // Not Checked

                      // Is Main
                      if (_kidsIds.length) {
                        rowSelection.setRowSelectionExcluded([
                          ...rowSelection.rowSelectionExcluded.filter((d) => !_kidsIds.find((k) => d.dbId === k.dbId)),
                          { dbId: item.dbId, id: item.id, versions: item.versions },
                          ..._kidsIds.map((id) => ({ ...id, versions: item.versions })),
                        ]);
                      } else {
                        // Not Main
                        rowSelection.setRowSelectionExcluded([
                          ...rowSelection.rowSelectionExcluded,
                          { dbId: item.dbId, id: item.id, versions: item.versions }
                        ]);
                      }
                    }
                  }
                }}
              />
            );
          },
          width: 70,
        },
        ...columns,
      ];
    }

    return columns;
  }, [rowSelection, columns, dataSource, t]);

  const {
    selectFiltersConfig,
    filtersConfig,
    checkboxConfig,
  } = useMemo(() => getConfig(state), [state]);

  const {
    newFiltersConfig,
    pagination,
    activeFilters,
    onSearch,
    defaultFilters,
    onTableChange,
    setPagination,
    onFiltersChange,
  } = useFilters({
    selectFiltersConfig,
    defaultActiveFilters,
    module: mod,
    filtersConfig,
    defaultPageSize: defaultActiveFilters.pageSize || 10,
  });

  const [showFilters, setShowFilters] = useState(false);
  const key = useMemo(() => published ? 'published' : 'unPublished', [published]);
  const pages = useMemo(() => Math.ceil(pagination.total / pagination.pageSize), [pagination]);

  useEffect(() => {
    onActiveFiltersChange(activeFilters);
  }, [activeFilters]);

  useEffect(() => {
    setSelectOptions((prev) => selectMaper[state](prev, data));
  }, [data.options]);

  useEffect(() => {
    const _abortController = new AbortController();

    if (!reset) {
      setLoading(true);
      setActiveFilters(activeFilters);

      if (state === 'locations') {
        SCLService.getAll(filterParams({
          ...fetchOptions,
          published,
          activeFilters,
        }), _abortController.signal)
          .then((d) => {
            if (d && d.data) {
              if (mounted.current) {
                setData({ [key]: { ...d.data } });
                setLoading(false);
              }
            }
          });
      }
      if (state === 'stakeholders') {
        StakeholderService.get(filterParams({
          ...fetchOptions,
          published,
          activeFilters,
        }), _abortController.signal)
          .then((d) => {
            if (d && d.data) {
              if (mounted.current) {
                setData({ [key]: { ...d.data } });
                setLoading(false);
              }
            }
          });
      }
      if (state === 'events') {
        EventsService.get(filterParams({
          ...fetchOptions,
          published,
          activeFilters,
        }), _abortController.signal)
          .then((d) => {
            if (d && d.data) {
              if (mounted.current) {
                setData({ [key]: { ...d.data } });
                setLoading(false);
              }
            }
          });
      }
      if (state === 'lir') {
        LirService.get(filterParams({
          ...fetchOptions,
          published,
          activeFilters,
        }), _abortController.signal)
          .then((d) => {
            if (d && d.data) {
              if (mounted.current) {
                setData({ [key]: { ...d.data } });
                setLoading(false);
              }
            }
          });
      }
    }

    return () => {
      _abortController.abort();
    }
  }, [activeFilters, user.language, reset]);

  useEffect(() => {
    if (reset) {
      onTableChange({ ...pagination, current: 1 });
    }
  }, [reset]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, total: data.totalItems }));
    setUnpublishedCountAll(data.totalItems);
  }, [data]);

  const canClearSearch = useMemo(() => {
    return !!activeFilters.search;
  }, [activeFilters]);

  const searchFilters = (
    <SearchFilters
      t={t}
      showFilters={showFilters}
      setShowFilters={setShowFilters}
      hasError={hasError}
      setHasError={setHasError}
      filtersConfig={newFiltersConfig}
      checkboxConfig={checkboxConfig}
      onSearch={(...props) => {
        if (typeof rowSelection?.clean === 'function') {
          rowSelection.clean();
        }
        onSearch(...props);
      }}
      canClear={canClearSearch}
      activeFilters={activeFilters}
      clearFilters={() => {
        if (hasFilter(activeFilters || {})) {
          if (typeof rowSelection?.clean === 'function') {
            rowSelection.clean();
          }
          onFiltersChange({});
        }
      }}
    />
  );

  return (
    <Style>
      <div className="header">
        {selectOption}
        {searchFilters}
      </div>
      <div className="no-box-shadow daf-table-wrapper">
        <DafTable
          className="no-padding"
          options={options}
          columns={_columns}
          data={dataSource}
          loading={loading}
          selectOptions={selectOptions}
          pagination={false}
          filtersConfig={selectFiltersConfig}
          rowKey="key"
          onFilterChange={(...props) => {
            if (typeof rowSelection?.clean === 'function') {
              rowSelection.clean();
            }
            onFiltersChange(...props);
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          defaultFilters={defaultFilters}
          onChange={(page, f, sorter) => onTableChange(pagination, f, sorter)}
          hideOnLoading={false}
          expandable={{
            onExpandedRowsChange: (r) => {
              setExpandedRows(r);
            },
            expandedRowKeys: expandedRows,
            rowExpandable: (r) => (r?.kids || []).length,
            expandedRowRender: (r) => {
              return (
                <Animated isActive={toggledKeys.includes(r.key)}>
                  <AntTable
                    className="no-header-table"
                    columns={_columns}
                    dataSource={r.kids}
                    expandable
                    expandedRowRender={() => null}
                    doInject={false}
                    expandIcon={() => <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-spaced" aria-label="Expand row"></button>}
                    pagination={false}
                  />
                </Animated>
              )
            }
          }}
          rowClassName={(rec) => expandedRows.includes(rec.key) ? 'expanded' : ''}
          expandIcon={(props) => expandIcon({ ...props, arrows: true, toggledKeys, setToggledKeys, loadingKeys })}
        />
        <TablePagination
          t={t}
          page={pagination?.current}
          totalPages={pages}
          goPrev={() => {
            onTableChange({ ...pagination, current: pagination.current - 1 });
          }}
          goNext={() => {
            onTableChange({ ...pagination, current: pagination.current + 1 });
          }}
          onChangePagination={(val) => {
            onTableChange({ ...pagination, current: 1, pageSize: val });
          }}
          canGoNext={pagination.current !== pages && pages}
          canGoPrev={pagination.current !== 1}
          loaded
          totalItems={pagination?.total}
          doTotalItems
          perPage={pagination.pageSize}
        />
      </div>
    </Style>
  );
}
